/**
 * App
 * ------
 * Specify vendor and app specific js files to be compiled
*/

// Bootstrap requires
require('./vendor/bootstrap-requires.js');

// Optional Vendor Requires
// require('./vendor/imagesloaded.pkgd.min.js');
// require('./vendor/jquery.actual.min');
// require('./vendor/jquery.validate.min');
// require('./vendor/object-visual-lock');
// require('./vendor/js.cookie');
// require('./vendor/slick-slider');
// require('./vendor/youtube-iframe-assistant');
// require('./vendor/picturefill');
// require('./vendor/waypoint');
// require('./vendor/waypoint-animate');

// Sliders
// require('./app/sliders/card-slider');

// ScrollTrigger
// require('./app/scrollTrigger);
var $ = jQuery.noConflict();
// App Requires
// require('./app/config');
// require('./app/helpers');
require('./app/primary-navigation');
// $(document).ready(function() {
//     $('#olark-wrapper .olark-launch-button').css('background-color', 'transparent!important');
// });
$('#searchform').css('display','none');

$('.hfe-search-form__input').attr('placeholder', 'Enter search terms...');
$('.hfe-search-submit').text('Search');
